export type JobOrderChange = {
  id: number;
  actionTimestamp: Date | undefined;
  actionById: string | undefined;
  actionByName: string | undefined;
  actionByEmail: string | undefined;
  fieldName: FieldName;
  logType: String;
  oldVal?: string | undefined;
  newVal?: string | undefined;
};

export enum FieldName {
  empty = "",
  jobOrder = "jobOrder",
  assignee_id = "assignee_id",
  covid19_testing = "covid19_testing",
  created_date = "created_date",
  fill_by_date = "fill_by_date",
  flight_notice = "flight_notice",
  job_type = "job_type",
  offsigner_accomodation = "offsigner_accomodation",
  offsigner_destination = "offsigner_destination",
  offsigner_dropoff_date = "offsigner_dropoff_date",
  offsigner_id = "offsigner_id",
  offsigner_leaving_from = "offsigner_leaving_from",
  offsigner_notes = "offsigner_notes",
  offsigner_pickup_date = "offsigner_pickup_date",
  offsigner_travel_timestamp = "offsigner_travel_timestamp",
  onsigner_accomodation = "onsigner_accomodation",
  onsigner_destination = "onsigner_destination",
  onsigner_dropoff_date = "onsigner_dropoff_date",
  onsigner_id = "onsigner_id",
  onsigner_leaving_from = "onsigner_leaving_from",
  onsigner_notes = "onsigner_notes",
  onsigner_pickup_date = "onsigner_pickup_date",
  onsigner_travel_timestamp = "onsigner_travel_timestamp",
  port = "port",
  publish = "publish",
  relief_reason = "relief_reason",
  relief_time = "relief_time",
  testing_location = "testing_location",
  vessel_id = "vessel_id",
  offsigner_deboarded = "offsigner_deboarded",
  onsigner_onboarded = "onsigner_onboarded",
  note = "note",
  onsigner_union_hall = "onsigner_union_hall",
  smis = "smis",
  unopened_job_order = "unopened_job_order",
  expiration_date = "expiration_date",
  issue_date = "issue_date",
  type = "type",
  extra = "extra",
  rating = "rating",
  modified_by_captain = "modified_by_captain"
}

export const FieldNameLabel: { [key in FieldName]: string } = {
  [FieldName.empty]: "",
  [FieldName.jobOrder]: "Job Order",
  [FieldName.assignee_id]: "Assignee",
  [FieldName.covid19_testing]: "COVID-19 Testing",
  [FieldName.created_date]: "Created Date",
  [FieldName.fill_by_date]: "Crew Change Needed",
  [FieldName.flight_notice]: "Fly 24hr Prior (Y/N)",
  [FieldName.job_type]: "Job Type",
  [FieldName.offsigner_accomodation]: "Offsigner - Hotel or Rental",
  [FieldName.offsigner_destination]: "Offsigner - Destination",
  [FieldName.offsigner_dropoff_date]: "Offsigner - Check Out / Drop Off Date",
  [FieldName.offsigner_id]: "Offsigner",
  [FieldName.offsigner_leaving_from]: "Offsigner - Leaving From",
  [FieldName.offsigner_notes]: "Offsigner - Comments",
  [FieldName.offsigner_pickup_date]: "Offsigner - Check In / Pick Up Date",
  [FieldName.offsigner_travel_timestamp]: "Offisgner - Time",
  [FieldName.onsigner_accomodation]: "Onsigner - Hotel or Rental",
  [FieldName.onsigner_destination]: "Onsigner - Destination",
  [FieldName.onsigner_dropoff_date]: "Onsigner - Check Out / Drop Off Date",
  [FieldName.onsigner_id]: "Onsigner",
  [FieldName.onsigner_leaving_from]: "Onsigner - Leaving From",
  [FieldName.onsigner_notes]: "Onsigner - Comments",
  [FieldName.onsigner_pickup_date]: "Onsigner - Check In / Pick Up Date",
  [FieldName.onsigner_travel_timestamp]: "Onsigner - Time",
  [FieldName.port]: "Port Relief Actual",
  [FieldName.publish]: "Publish to Job Board",
  [FieldName.relief_reason]: "Reason",
  [FieldName.relief_time]: "Estimated Relief Time (hours)",
  [FieldName.testing_location]: "Testing Location",
  [FieldName.vessel_id]: "Vessel",
  [FieldName.offsigner_deboarded]: "Offsigner - Deboarded",
  [FieldName.onsigner_onboarded]: "Onsigner - Onboarded",
  [FieldName.note]: "Job Order Notes",
  [FieldName.onsigner_union_hall]: "Onsigner - Union Hall",
  [FieldName.smis]: "SMIS Job #",
  [FieldName.unopened_job_order]: "New Flag",
  [FieldName.expiration_date]: "Expiration Date",
  [FieldName.issue_date]: "Issue Date",
  [FieldName.type]: "Type",
  [FieldName.extra]: "Extra",
  [FieldName.rating]: "Rating",
  [FieldName.modified_by_captain]: "Modified By Captain Flag"
};
